module.exports = __webpack_public_path__ + "img/pef_investment_overview_icon01.72cd7075.svg";